var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVimeo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "24px",
    viewBox: "0 0 28 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 24") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Social-icons",
    transform: "translate(-51.000000, -3.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.9863918,8.55235105 C78.861265,11.2536356 76.9581134,14.951317 73.2760618,19.6462623 C69.4688835,24.548465 66.2479634,27 63.6141766,27 C61.9814037,27 60.5997594,25.5075728 59.4718686,22.5218512 C58.718483,19.7841448 57.9659725,17.0464385 57.211712,14.3087321 C56.3734502,11.3238777 55.4756877,9.82971611 54.5140492,9.82971611 C54.3040463,9.82971611 53.571661,10.2667779 52.3160184,11.1365655 L51,9.45509173 C52.3816443,8.25230468 53.7440384,7.04951762 55.0854322,5.844129 C56.928208,4.26671757 58.3133524,3.43682051 59.2347403,3.35270347 C61.4135208,3.145446 62.7549145,4.62139666 63.2580466,7.78055546 C63.8023042,11.1894638 64.1794345,13.3097337 64.3903124,14.1396308 C65.0194462,16.9683917 65.7107059,18.3810378 66.4649665,18.3810378 C67.0503497,18.3810378 67.931487,17.463555 69.1048784,15.6277221 C70.2773948,13.7936236 70.9056536,12.3983212 70.9896548,11.4383462 C71.1576572,9.85573169 70.5293984,9.06225645 69.1048784,9.06225645 C68.4346191,9.06225645 67.7433594,9.2148812 67.0328494,9.51666194 C68.4092437,5.05065376 71.0377805,2.88182144 74.9184598,3.00496186 C77.7955001,3.0890789 79.1526441,4.93791957 78.9863918,8.55235105",
    id: "Fill-24"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVimeo);
export default __webpack_public_path__ + "static/media/VIMEO.476b42b0e9066b84a253418b11b65aba.svg";
export { ForwardRef as ReactComponent };